import { prefixerI } from './common'

export const ROUTE_REPORTE_GUIAS = prefixerI('reporteGuias')
export const ROUTE_REPORTE_ALCANCES = prefixerI('reporteAlcances')
export const ROUTE_VIAJES_PLANTA = prefixerI('reporteViajesPlanta')
export const ROUTE_DISTRIBUTIVO_PAGO_LOGISTICO = prefixerI('distributivoPagoLogistico')
